import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from './styles.module.scss';

const QuestionBlock = ({ title, isActive }) => (
	<div
		className={cx(styles.QuestionBlock, {
			[styles.QuestionBlock__active]: isActive
		})}
	>
		<div className={styles.QuestionBlock_Title}>{title}</div>
		<div
			className={cx(styles.QuestionBlock_ControlButton, {
				[styles.QuestionBlock_ControlButton__active]: isActive
			})}
		>
			<Icon
				icon="round-arrow-down"
				className={cx(styles.QuestionBlock_Icon, PVI_NO_STYLES_CLASSNAME)}
				useClassName={PVI_NO_STYLES_CLASSNAME}
			/>
		</div>
	</div>
);

QuestionBlock.propTypes = {
	title: PropTypes.string.isRequired,
	isActive: PropTypes.bool.isRequired
};

QuestionBlock.defaulProps = {
	isActive: false
};

export default QuestionBlock;
